/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        list: {
            item: {
                borderBottomWidth: {
                    value: "1px",
                    type: "dimension",
                },
                borderStyle: {
                    value: "solid",
                    type: "strokeStyle",
                },
                borderColor: {
                    value: "#dadada",
                    type: "color",
                },
                checkbox: {
                    marginRight: {
                        value: "24px",
                        type: "dimension",
                    },
                },
                content: {
                    gap: {
                        value: "16px",
                        type: "dimension",
                    },
                    label: {
                        default: {
                            fontSize: {
                                value: "1rem",
                                type: "dimension",
                            },
                            fontWeight: {
                                value: 400,
                                type: "number",
                            },
                            lineHeight: {
                                value: "1.5rem",
                                type: "dimension",
                            },
                            letterSpacing: {
                                value: "0.2px",
                                type: "dimension",
                            },
                            color: {
                                value: "#282e37",
                                type: "color",
                            },
                        },
                        title: {
                            fontSize: {
                                value: "1rem",
                                type: "dimension",
                            },
                            fontWeight: {
                                value: 600,
                                type: "number",
                            },
                            lineHeight: {
                                value: "1.5rem",
                                type: "dimension",
                            },
                            letterSpacing: {
                                value: "0.2px",
                                type: "dimension",
                            },
                            color: {
                                value: "#282e37",
                                type: "color",
                            },
                        },
                        secondary: {
                            fontSize: {
                                value: "0.875rem",
                                type: "dimension",
                            },
                            fontWeight: {
                                value: 400,
                                type: "number",
                            },
                            lineHeight: {
                                value: "1.25rem",
                                type: "dimension",
                            },
                            letterSpacing: {
                                value: "0.2px",
                                type: "dimension",
                            },
                            color: {
                                value: "#6f7377",
                                type: "color",
                            },
                        },
                    },
                    icon: {
                        width: {
                            value: "24px",
                            type: "dimension",
                        },
                        height: {
                            value: "24px",
                            type: "dimension",
                        },
                    },
                    media: {
                        width: {
                            value: "84px",
                            type: "dimension",
                        },
                        height: {
                            value: "84px",
                            type: "dimension",
                        },
                        borderRadius: {
                            value: "12px",
                            type: "dimension",
                        },
                    },
                },
                spacing: {
                    none: {
                        paddingTop: {
                            value: "0px",
                            type: "dimension",
                        },
                        paddingBottom: {
                            value: "0px",
                            type: "dimension",
                        },
                    },
                    tight: {
                        paddingTop: {
                            value: "12px",
                            type: "dimension",
                        },
                        paddingBottom: {
                            value: "12px",
                            type: "dimension",
                        },
                    },
                    spacious: {
                        paddingTop: {
                            value: "24px",
                            type: "dimension",
                        },
                        paddingBottom: {
                            value: "24px",
                            type: "dimension",
                        },
                    },
                },
                plain: {
                    paddingLeft: {
                        value: "0px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "0px",
                        type: "dimension",
                    },
                },
                clickable: {
                    paddingLeft: {
                        value: "8px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "8px",
                        type: "dimension",
                    },
                },
                default: {
                    backgroundColor: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#f3f3f3",
                        type: "color",
                    },
                },
                active: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                },
                selected: {
                    backgroundColor: {
                        value: "#d7f6ff",
                        type: "color",
                    },
                },
            },
            sectioned: {
                gap: {
                    value: "48px",
                    type: "dimension",
                },
                header: {
                    paddingBottom: {
                        value: "12px",
                        type: "dimension",
                    },
                    borderBottomWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    borderBottomStyle: {
                        value: "solid",
                        type: "strokeStyle",
                    },
                    borderBottomColor: {
                        value: "#a0a2a5",
                        type: "color",
                    },
                    label: {
                        fontSize: {
                            value: "0.75rem",
                            type: "dimension",
                        },
                        fontWeight: {
                            value: 600,
                            type: "number",
                        },
                        lineHeight: {
                            value: "1rem",
                            type: "dimension",
                        },
                        letterSpacing: {
                            value: "0.3px",
                            type: "dimension",
                        },
                        color: {
                            value: "#282e37",
                            type: "color",
                        },
                    },
                },
            },
        },
    },
};
export default tokens;
